import ServerTable from '../components/ServerTable';
import { BrandBadge } from '../brands';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import { fetchRejected, ARCHIVE_PAGE_SIZE } from '../store/shownDataSlice';
import * as common from './common';

export const REJECTED_NAMES = {
    "cheaper_elsewhere": "Mujal soodsam",
    "over_budget": "Üle eelarve",
    "trip_cancelled": "Reis jääb ära",
    "other": "Muu põhjus",
    "cancelled_via_platform": "Tagasi lükatud platvormi kaudu"
};

function RejectedTable({  }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const data = useSelector((state) => state.shownData.rejected);
    const total = useSelector((state) => state.shownData.rejectedTotal);

    const [page, setPage] = useState(0);
    const [search, setSearch] = useState('');
    const [sortKey, setSortKey] = useState('');
    const [sortDir, setSortDir] = useState('');
    const [showAll, setShowAll] = useState(false);
    const brandFilter = useSelector((state) => state.shownData.brandFilter);

    // Start from the first page whenever the brand filter changes
    useEffect(() => { setPage(0); }, [brandFilter]);

    useEffect(() => {
        dispatch(fetchRejected({
            limit: ARCHIVE_PAGE_SIZE,
            offset: page * ARCHIVE_PAGE_SIZE,
            search,
            sortKey,
            sortDir,
            all: showAll,
            brand: brandFilter,
        }));
    }, [page, search, sortKey, sortDir, showAll, brandFilter]);


    return (
        <ServerTable
            style={{ width: '100%' }}
            data={data}
            total={total}
            pageSize={ARCHIVE_PAGE_SIZE}
            page={page}
            search={search}
            sortKey={sortKey}
            sortDir={sortDir}
            showAll={showAll}
            onPageChange={setPage}
            onSearchChange={(text) => { setSearch(text); setPage(0); }}
            onSortChange={(key, dir) => { setSortKey(key); setSortDir(dir); setPage(0); }}
            onToggleShowAll={() => { setShowAll((v) => !v); setPage(0); }}
            columnNames={[
                "Reisi kuupäev",
                "Päringu kuupäev",
                "Firma",
                "Sihtkohad",
                "Reisijad",
                "Vahemaa",
                "Maksumus",
                "Põhjus",
            ]}
            serverSortKeys={[
                "depart",     // Reisi kuupäev
                "created",    // Päringu kuupäev
                null,         // Firma
                null,         // Sihtkohad
                null,         // Reisijad
                "distance",   // Vahemaa
                "price",      // Maksumus
                null,         // Põhjus
            ]}
            columnRenderers={[
                (row) => (<a onClick={() => navigate("/platform/answeredQuery/" + row["query_id"])}>{common.displayDepart(row)}</a>),
                (row) => (<p>{common.prettifyTimestamp(row["query_created"])}</p>),
                (row) => (<p>{row["query_brand"] === "triobuss" && <><BrandBadge brand={row["query_brand"]} />&nbsp;</>}{row["query_company"] || (<i style={{ color: "#668" }}>{row["query_fullname"]}</i>)}</p>),
                (row) => (<p style={{ maxWidth: 192, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{common.displayPrettyRoute(row)}</p>),
                (row) => (<p>{row["query_passengers"]}</p>),
                (row) => (<p>{common.displayDistance(row)}</p>),
                (row) => (<p>{common.displayPrice(row["query_response_price"])}</p>),
                (row) => (<p>{REJECTED_NAMES[row["query_response_reject_reason_reason"]]}</p>),
            ]}
        />
    );
}

export default RejectedTable;
